import Vue from 'vue'

export default {
  getAll () {
    return Vue.http.get('/rental/franchiseeMachines', {})
  },
}



// WEBPACK FOOTER //
// ./src/services/rental/franchiseeMachine.js